import { purify } from "../../_src/components/purify";

export function searchNotas() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")

    function search(loadMore) {
        btnLoadMore.classList.add("loading");

        fetch(`/ifag/publicacoes/ajax/publicacoes.html/p${btnLoadMore.getAttribute("data-page")}?&loadmore=${loadMore}`, {
            method: "POST",
        })
        .then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#result-load-more-notes-collection").insertAdjacentHTML('beforebegin', response);
            } else {
                document.querySelector("#result-notes-collection").innerHTML = purify(response);
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore.classList.remove("loading")

            if (loadMore) {
                if (parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.total)) {
                    btnLoadMore.classList.add('hidden');
                }
            }
        });
    }

    btnLoadMore.addEventListener("click", function() { search(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
}

if (document.querySelector("#result-publications")) {
    searchNotas();
}
